import { createRoot } from "react-dom/client";

import { Main } from "./main";
import { UserSessionProvider } from "./use-user-context";

document.body.innerHTML = '<div id="app"></div>';
const container = document.getElementById("app");

if (container) {
  const root = createRoot(container);

  root.render(
    <UserSessionProvider>
      <Main />
    </UserSessionProvider>,
  );
}
